<div class="container d-flex justify-content-left align-items-left">
  <button
    type="button"
    class="btn-govco fill-btn-govco icon-btn-govco btn__volver flecha"
    (click)="goBack()"
    aria-label="Volver">
    <span class="govco-svg govco-arrow-circle-left" aria-hidden="true"></span>
    <span>{{ 'volver' | translate }}</span>
  </button>
</div>
<div class="container d-flex justify-content-center align-items-center min-vh-100">
  <div class="text-center" style="max-width: 450px;">
    <div *ngIf="isFuncionario; else esEmpresa">
      <h3 class="wrapper__form__title h3-tipografia-govco mb-0">
        {{ 'login.funcionario' | translate }}
      </h3>
      <p class="wrapper__form__title h4-tipografia-govco text-secondary mb-4" style="font-size: 0.9rem;">
        {{ 'login.subtitulo-funcionario' | translate }}
      </p>
    </div>
    
    <ng-template #esEmpresa>
      <h3 class="wrapper__form__title h3-tipografia-govco mb-0">
        {{ 'login.empresa' | translate }}
      </h3>
      <p class="wrapper__form__title h4-tipografia-govco text-secondary mb-4" style="font-size: 0.9rem;">
        {{ 'login.subtitulo-empresa' | translate }}
      </p>
    </ng-template>
    
    <div class="wrapper__headerComponent">
      <div class="wrapper__form">
        <form [formGroup]="loginForm" class="wrapper__form__content" *ngIf="isFuncionario; else esEmpresaLogin">
          <!-- Usuario -->
          <div class="entradas-de-texto-govco m-2 text-start">
            <div class="d-flex flex-row align-items-center">
              <label for="username">
                {{ 'login.usuario' | translate }}
              </label>
              <span class="text-danger">*</span>
            </div>
            <input
              type="text"
              class="form-control"
              id="usernamePersona"
              formControlName="username"
              (input)="onInputChange($event, 50, 'username')"
              placeholder="{{ 'login.ingrese-usuario' | translate }}"
              [ngClass]="{
                'is-valid':
                  loginForm.get('username')?.valid &&
                  loginForm.get('username')?.touched &&
                  loginForm.get('username')?.dirty,
                'is-invalid': 
                  loginForm.get('username')?.invalid && 
                  loginForm.get('username')?.touched &&
                  loginForm.get('username')?.dirty,
              }"
              appUppercaseOnly
              typeData="accountant"
              maxlength="20"
              value=""
              onkeyup="this.setAttribute('value', this.value);" />
            <span id="counter" class="counter-text" role="status"
            >0/20</span>
          </div>

          <!-- Contraseña -->
          <div class="entradas-de-texto-govco m-2 text-start">
            <div class="d-flex flex-row align-items-center">
              <label for="contrasena">
                {{ 'login.contrasenia' | translate }}
              </label>
              <span class="text-danger">*</span>
            </div>
            <div class="d-flex flex-row align-items-center">
              <div class="col-11">
                <div class="input-container">
                  <input
                    [type]="showPassword ? 'text' : 'password'"
                    class="form-control actived-events-govco"
                    id="contrasenaPersona"
                    formControlName="contrasena"
                    placeholder="{{'login.ingrese-contrasenia' | translate}}"
                    (input)="onInputChange($event, 100, 'contrasena')"
                    [ngClass]="{
                      'is-valid': 
                        loginForm.get('contrasena')?.valid && 
                        loginForm.get('contrasena')?.touched,
                      'is-invalid': 
                        loginForm.get('contrasena')?.invalid && 
                        loginForm.get('contrasena')?.touched
                    }"
                    (keydown.enter)="onSubmit('login')"
                    minlength="8"
                    typeData="password"
                    onkeyup="this.setAttribute('value', this.value);" />
                </div>
              </div>
              <div class="col-1 mx-2">
                <button
                  *ngIf="showPassword"
                  class="govco-icon govco-eye"
                  [ngClass]="{
                    'me-4':
                      loginForm.get('contrasena')?.valid &&
                      loginForm.get('contrasena')?.touched &&
                      !loginForm.get('contrasena')?.pristine,
                    }"
                  aria-label="Ocultar contraseña"
                  (click)="showPassword = !showPassword"
                  style="border: none; background-color: white;"
                  type="button"
                  aria-label="Ocultar contraseña">
                </button>
                <button
                  *ngIf="!showPassword"
                  class="govco-icon govco-eye-slash"
                  [ngClass]="{
                    'me-4':
                      loginForm.get('contrasena')?.valid &&
                      loginForm.get('contrasena')?.touched,
                  }"
                  aria-label="Mostrar contraseña"
                  (click)="showPassword = !showPassword"
                  style="border: none; background-color: white;"
                  type="button"
                  aria-label="Mostrar contraseña">
                </button>
              </div>
            </div>
            <small class="text-muted">
              {{'login.minimo-caracteres' | translate}}
            </small>
          </div>

          <div class="text-end me-3 mb-3">
            <button
              type="button"
              class="text-primary text-decoration-none"
              (click)="openModalContrasenia()"
              [attr.aria-label]="'login.olvido-contrasenia-funcionario' | translate">
              {{ 'login.olvido-contrasenia-funcionario' | translate }}
            </button>
          </div>
          <div class="row justify-content-center">
            <div class="col-12">
              <button
                type="button"
                (click)="onSubmit('login')"
                [disabled]="loginForm.invalid"
                class="btn-govco fill-btn-govco w-100"
                aria-label="Entrar">
                {{ 'login.entrar' | translate }}
              </button>
            </div>
          </div>
        </form>
        <!-- Empresa -->
        <ng-template #esEmpresaLogin>
          <form [formGroup]="loginFormEmpresa" class="wrapper__form__content">
            <!-- Usuario -->
            <div class="entradas-de-texto-govco m-2 text-start">
              <div class="d-flex flex-row align-items-center">
                <label for="username">
                  {{ 'login.usuario' | translate }}
                </label>
                <span class="text-danger">*</span>
              </div>
              <input
                type="text"
                class="form-control"
                id="usernameEmpresa"
                formControlName="username"
                (input)="onInputChangeEmpresa($event, 100, 'username')"
                placeholder="{{ 'comun-label.email' | translate }}"
                [ngClass]="{
                  'is-valid':
                    loginFormEmpresa.get('username')?.valid &&
                    loginFormEmpresa.get('username')?.touched &&
                    loginFormEmpresa.get('username')?.dirty,
                  'is-invalid': 
                    loginFormEmpresa.get('username')?.invalid && 
                    loginFormEmpresa.get('username')?.touched &&
                    loginFormEmpresa.get('username')?.dirty,
                }"
                maxlength="100"
                value=""/>
                <div
                  class="invalid-feedback"
                  *ngIf="loginFormEmpresa.get('username')?.errors?.['pattern']">
                  {{ 'comun-label.email-pattern' | translate }}
                </div>
            </div>

            <!-- Contraseña -->
            <div class="entradas-de-texto-govco m-2 text-start">
              <div class="d-flex flex-row align-items-center">
                <label for="contrasena">
                  {{ 'login.contrasenia' | translate }}
                </label>
                <span class="text-danger">*</span>
              </div>
              <div class="d-flex flex-row align-items-center">
                <div class="col-11">
                  <div class="input-container">
                    <input
                      [type]="showPassword ? 'text' : 'password'"
                      class="form-control actived-events-govco"
                      id="contrasenaEmpresa"
                      formControlName="contrasena"
                      placeholder="{{'login.ingrese-contrasenia' | translate}}"
                      [ngClass]="{
                        'is-valid': 
                          loginFormEmpresa.get('contrasena')?.valid && 
                          loginFormEmpresa.get('contrasena')?.touched,
                        'is-invalid': 
                          loginFormEmpresa.get('contrasena')?.invalid && 
                          loginFormEmpresa.get('contrasena')?.touched
                      }"
                      (keydown.enter)="onSubmitEmpresa()"
                      minlength="8"
                      typeData="password"
                      onkeyup="this.setAttribute('value', this.value);" />
                  </div>
                </div>
                <div class="col-1 mx-2">
                  <button
                    *ngIf="showPassword"
                    class="govco-icon govco-eye"
                    [ngClass]="{
                      'me-4':
                        loginFormEmpresa.get('contrasena')?.valid &&
                        loginFormEmpresa.get('contrasena')?.touched &&
                        !loginFormEmpresa.get('contrasena')?.pristine,
                      }"
                    aria-label="Ocultar contraseña"
                    (click)="showPassword = !showPassword"
                    style="border: none; background-color: white;"
                    type="button"
                    aria-label="Ocultar contraseña">
                  </button>
                  <button
                    *ngIf="!showPassword"
                    class="govco-icon govco-eye-slash"
                    [ngClass]="{
                      'me-4':
                        loginFormEmpresa.get('contrasena')?.valid &&
                        loginFormEmpresa.get('contrasena')?.touched,
                    }"
                    aria-label="Mostrar contraseña"
                    (click)="showPassword = !showPassword"
                    style="border: none; background-color: white;"
                    type="button"
                    aria-label="Mostrar contraseña">
                  </button>
                </div>
              </div>
              <small class="text-muted">
                {{'login.minimo-caracteres' | translate}}
              </small>
            </div>

            <div class="text-end me-3 mb-3">
              <button
                type="button"
                class="text-primary text-decoration-none"
                (click)="openModalContrasenia()"
                [attr.aria-label]="'login.olvido-contrasenia-funcionario' | translate">
                {{ 'login.olvido-contrasenia-funcionario' | translate }}
              </button>
            </div>
            <div class="row justify-content-center">
              <div class="col-12">
                <button
                  type="button"
                  (click)="onSubmitEmpresa()"
                  [disabled]="loginFormEmpresa.invalid"
                  class="btn-govco fill-btn-govco w-100"
                  aria-label="Entrar">
                  {{ 'login.entrar' | translate }}
                </button>
              </div>
            </div>
          </form>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Modales -->
<div *ngIf="openModalDobleFactorAutenticacion">
  <app-modal-doble-factor
    [usuarioId]="usuarioId"
    (verificarDobleFactor)="verificarDobleFactor($event)">
  </app-modal-doble-factor>
</div>

<div *ngIf="openModalTipoUsuario">
  <app-modal-tipo-usuario
    [tiposUsuario]="tiposUsuario"
    (tipoUsuarioEmitter)="obtenerTipoUsuario($event)">
  </app-modal-tipo-usuario>
</div>

<div *ngIf="openModalFPassword">
  <app-modal-restablecer-contrasenia
  [isFuncionario]="isFuncionario"></app-modal-restablecer-contrasenia>
</div>

